import { Row } from 'antd';
import React, { ReactElement, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../../store';
import { setOtherCourierService } from '../../../store/actions/inPatientAction';
import { GUTTOR_SPACE } from '../../constants/commonConstants';
import { courierProviders } from '../../constants/commonConstants';
import { FormSelect, FormTextInput } from '../crmFormElement/FormInput';
import { NewAdmissionState } from '../../../store/models/newAdmissionModel';
import { setModalSwitch } from '../../../store/actions/newAdmissionAction';

const CourierDetail = ({ form }: any): ReactElement => {
  const commonDetail = { form };
  const { otherCourierOptionService } = useSelector((state: RootState): any => state?.selectedInPatientDetail);
  const { courierReceiptNumber,
     courierProvider: draftCourierProvider} = useSelector((state: RootState): any => state?.newAdmission?.modalFormValue || {});
  const { draftValue } = useSelector((state: RootState): NewAdmissionState => state.newAdmission);
  const dispatch = useDispatch();

  useEffect((): void => {
    if (courierReceiptNumber && draftValue === 'settlement') {
      form?.setFieldsValue({ courierReceiptNumber });
    }
  }, [draftValue]);

  useEffect((): any => {
    dispatch(setModalSwitch(true));
   if (otherCourierOptionService || draftCourierProvider ) {
   form?.validateFields()?.then((): any => {
      dispatch(setModalSwitch(false));
     }).catch((): any => {
      dispatch(setModalSwitch(true));
     });
    }
  }, [otherCourierOptionService]);

  const handleChange = async (selectedOption: any): Promise<any> => {
    form.resetFields(['courierTrackId']);
    form.resetFields(['courierReceiptNumber']);

    dispatch(setOtherCourierService(selectedOption));
    await form?.validateFields()?.then((): any => {
      dispatch(setModalSwitch(false));
     }).catch((): any => {
      dispatch(setModalSwitch(true));
     });
  };
  const onInputChange = async (ele: any, label: any): Promise<any> => {
    await form?.validateFields()?.then((): any => {
      dispatch(setModalSwitch(false));
    }).catch((): any => {
      dispatch(setModalSwitch(true));

    });
  };

  return (
    <React.Fragment>
      <Row gutter={GUTTOR_SPACE}>
        <FormSelect detail={{
          ...commonDetail,
          key: 'courierProvider',
          size: 12,
          options: courierProviders || [],
          showSearch : true,
          onChange: handleChange,
          isName: true,
        }} />
        {otherCourierOptionService === 'Hand Delivery' || form?.getFieldsValue(['courierProvider'])?.courierProvider === 'Hand Delivery' ?
        <FormTextInput detail={{
          ...commonDetail,
          key: 'courierReceiptNumber',
          size: 12,
          onChange: onInputChange,
        }}/> :
        <FormTextInput detail={{
          ...commonDetail,
          key: 'courierTrackId',
          size: 12,
          onChange: onInputChange,

        }}/>}
        {otherCourierOptionService === 'Others' || form?.getFieldsValue(['courierProvider'])?.courierProvider === 'Others' ?
          <FormTextInput detail={{
            ...commonDetail,
            key: 'otherCourierProvider',
            size: 12,
            onChange: onInputChange,

          }} /> : <></>}
      </Row>
    </React.Fragment>
  );
};

export default CourierDetail;
